import {
} from "../mutations-types";
import axios from "axios";
import api from "@/api";
import Cookies from "js-cookie";
const CookieName = process.env.VUE_APP_CookieName;
let accessInfo;
let user_id = 0;
if (Cookies.get(CookieName) !== undefined) {
  accessInfo = JSON.parse(Cookies.get(CookieName));
  user_id = accessInfo.user_id;
}

const actions = {
  // **** 공통사용모듈 **** //
  async getApiDataQuery({ commit }, endpoint) {
    try {
      const res = await axios.get(`${endpoint}`);
      if (res) {
        return res;
      }
    } catch (err) {
      return alert(`${endpoint} error`);
    }
  },

  async getDataQuery({ commit }, payload) {
    payload.updUpk = user_id;
    try {
      const rootEndpoint = payload.endpointUser ? 'user' : 'admin';
      const res = await api.post(`/${rootEndpoint}/${payload.endpoint}`, payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      return alert(`${payload.endpoint} error`);
    }
  },

  async saveDataQuery({ commit }, payload) {
    payload.updUpk = user_id;
    try {
      const rootEndpoint = payload.endpointUser ? 'user' : 'admin';
      const res = await api.put(`/${rootEndpoint}/${payload.endpoint}`, payload);
      if (res) {
        return res.data;
      }
    } catch (err) {
      return alert(`${payload.endpoint} error`);
    }
  },

  // 로그인 전 처리(find pw)
  async saveDataPreLoginQuery({ commit }, payload) {
    try {
      let res = null;
      if (payload.queryMethod === "POST") {
        res = await api.post(`/${payload.endpoint}`, payload);
      } else {
        res = await api.put(`/${payload.endpoint}`, payload);
      }
      if (res) {
        return res.data;
      }
    } catch (err) {
      // console.log('', `${err.response}`);
      return alert(`${payload.endpoint} error ${err}`);
    }
  },
}

const mutations = {}
const state = {}
const getters = {}
export default {
  state,
  getters,
  actions,
  mutations,
}
